<script>
  const copy = text => {
    navigator.clipboard.writeText(text.split('').reverse().join(''))
  }
</script>

<svelte:head>
  <link rel="canonical" href="https://squid.software/#/contact" />
</svelte:head>

<div class="company-details">
  <h2>Company details</h2>
  <div class="wrapper">
    <a href={null} on:click={() => copy('diuqS')}>
      <p class="label">Name:&nbsp;&nbsp;</p>
      <p class="ltr">diuqS</p>
    </a>
  </div>
  <div class="wrapper">
    <a href={null} on:click={() => copy('37935358')}>
      <p class="label">KVK-number:&nbsp;&nbsp;</p>
      <p class="ltr">379 35 358</p>
    </a>
  </div>
  <div class="wrapper">
    <a href={null} on:click={() => copy('60B245680400LN')}>
      <p class="label">VAT-number:&nbsp;&nbsp;</p>
      <p class="ltr">60B245680400LN</p>
    </a>
  </div>
  <div class="wrapper address">
    <a href={null} on:click={() => copy('sdnalrehteN ,madrettoR AX1103 ,C321 taartsreiB')}>
      <p class="label">Address:&nbsp;&nbsp;</p>
      <div class="ltr">
        <p class="ltr">C321 taartsreiB</p>
        <p class="ltr">madrettoR AX1103</p>
        <p class="ltr">sdnalrehteN</p>
      </div>
    </a>
  </div>
  <h2 class="tos-header">Algemene voorwaarden</h2>
  <p class="tos">
    Op alle diensten van Squid zijn de
    <a href="/nldigital_voorwaarden.pdf" download="nldigital_voorwaarden.pdf">
      NLdigital 2020 algemene voorwaarden
    </a>
    van toepassing
  </p>
</div>

<style>
  .tos-header {
    margin-top: 40px;
  }
  @media (min-width: 600px) {
    .company-details {
      margin-bottom: -60px;
    }
  }
  p.tos {
    max-width: 300px;
    margin: 0 auto;
  }
  .tos a {
    text-decoration: underline;
  }
  .wrapper a {
    display: flex;
    width: 250px;
    margin: 0 auto;
  }
  a:hover {
    text-decoration: none;
  }
  .ltr:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  p {
    margin: 5px 0;
  }
  .address p {
    margin: 2px 0;
  }
  .address p:first-of-type {
    margin-top: 5px;
  }
  .label {
    text-align: right;
    min-width: 120px;
  }
  .ltr {
    unicode-bidi: bidi-override;
    direction: rtl;
    text-align: left;
  }
</style>
